import { Component, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BoardsService } from 'src/app/service/boards.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-from-template',
    templateUrl: './from-template.component.html',
    styleUrls: ['./from-template.component.scss'],
    standalone: false ,  // NOSONAR
})
export class FromTemplateComponent implements OnInit {

  temp4;
  selected_period;
  periodData;

  selected_template;

  temp;
  templates;

  selected_date;

  successMessage = '';
  errorMessage = '';


  userID;
  usertemp: string;
  userInfo: any;

  temporaryArr = [];


  constructor(private  readonly ngxUiLoaderService: NgxUiLoaderService, private readonly boardService: BoardsService,
	private readonly router: Router) {
    this.ngxUiLoaderService.start("loader-01");

    //fetch from local-storage
    this.temp4 = localStorage.getItem('period-data');
    this.periodData = JSON.parse(this.temp4);

    this.temp = localStorage.getItem('template-data');

    JSON.parse(this.temp).forEach(element => {
      if (element.templateID == 1 || element.templateID == 4) { // NOSONAR
        this.temporaryArr.push(element);
      }
    });

    this.templates = this.temporaryArr;

    this.ngxUiLoaderService.stop("loader-01");
  }

  ngOnInit(): void { // NOSONAR
		//  do something 
	}

  addtask() {


    

    const userData = sessionStorage?.getItem('FGA');
		if (userData) {
			this.userID = JSON.parse(userData)?.user?.userPrincipalName;
		}


    let baseDate;

    // format base date

    if (this.selected_date) {

      const dueYear = this.selected_date.split('-');

      //  mm-dd-yyyy hh:mi
      baseDate = dueYear[1] + '-' + dueYear[2] + '-' + dueYear[0];
    }



    console.info("period", this.selected_period, "template", this.selected_template,
      "date ", this.selected_date);

    if (this.selected_period == undefined || this.selected_template == undefined || this.selected_date == undefined) { // NOSONAR
      this.errorMessage = "Please fill in the required fields!";
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);
    }
    else {
      // call service


      const dataArr = {
        "intuserID": this.userID,
        "templateID": this.selected_template,
        "periodID": this.selected_period,
        "baseDate": baseDate
      };



      this.ngxUiLoaderService.start("loader-01");

      this.boardService.addFromTemplateTask(dataArr).subscribe(result => {
        if (!result) {
          this.errorMessage = 'Task already exists!';
          setTimeout(() => {
            this.successMessage = '';
            this.errorMessage = '';
          }, 6500);
          this.ngxUiLoaderService.stop("loader-01");
        }

        else if (result) {

		  this.router.navigate(['./board']);
        }
      });




    }
  }

}
